export const EQUAL = 'eq';
export const NOT_EQUAL = 'ne';
export const GREATER_THAN = 'gt';
export const GREATER_THAN_OR_EQUAL = 'ge';
export const LESS_THAN = 'lt';
export const LESS_THAN_OR_EQUAL = 'le';
export const LIKE = 'lk';
export const IN = 'in';
export const NOT_IN = 'ni';
export const STARTS_WITH = 'sw'; // Transformed into 'lk' by class Filter
export const ENDS_WITH = 'ew'; // Transformed into 'lk' by class Filter
